module.exports = __webpack_public_path__ + "img/meetingsclient5.140c2e87.png";